import React, { useRef, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { useSocket } from "../../Utils/socket";
import { OPERATE_MQTT } from "../../helpers/socketEvent";

function DemoRoom() {
  const socket: any = useSocket();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const videoRef = useRef<HTMLVideoElement>(null);

  const [triggeredTimes, setTriggeredTimes] = useState<number[]>([]);

  const videoTriggers = [
    { time: 42, slave: "70B8F603FE98", data: "02XX1" },
    { time: 55, slave: "70B8F603FE98", data: "06XX1" },

    { time: 70, slave: "404CCA43FC38", data: "01XX0" },
    { time: 70.5, slave: "404CCA43FC38", data: "01XX1" },
    { time: 72, slave: "404CCA43FC38", data: "01XX0" },
    { time: 72.5, slave: "404CCA43FC38", data: "01XX1" },
    { time: 74, slave: "404CCA43FC38", data: "01XX0" },
    { time: 74.5, slave: "404CCA43FC38", data: "01XX1" },

    { time: 78, slave: "404CCA4368DC", data: "01XX0" },
    { time: 79, slave: "404CCA4368DC", data: "01XX1" },
    { time: 80, slave: "404CCA4368DC", data: "01XX0" },
    { time: 81, slave: "404CCA4368DC", data: "01XX1" },
    { time: 82, slave: "404CCA4368DC", data: "01XX0" },
    { time: 83, slave: "404CCA4368DC", data: "01XX1" },

    { time: 105, slave: "404CCA43ECC0", data: "02XX0" },
    { time: 105, slave: "404CCA4462A8", data: "01XX0" },
    { time: 105, slave: "404CCA4462A8", data: "02XX0" },
    { time: 105, slave: "404CCA4462A8", data: "03XX0" },

    { time: 111, slave: "404CCA43ECC0", data: "02XX1" },
    { time: 111, slave: "404CCA4462A8", data: "01XX1" },
    { time: 111, slave: "404CCA4462A8", data: "02XX1" },
    { time: 111, slave: "404CCA4462A8", data: "03XX1" },

    { time: 162, slave: "404CCA43ECC0", data: "02XX0" },
    { time: 165, slave: "404CCA43ECC0", data: "02XX1" },

    { time: 173, slave: "404CCA43ECC0", data: "02141" },

    { time: 180, slave: "404CCA443E5C", data: "01XX1" },

    { time: 184, slave: "404CCA4462A8", data: "01XX0" },
    { time: 184.5, slave: "404CCA43FC38", data: "01XX0" },
    { time: 186, slave: "404CCA4368DC", data: "01XX0" },
    { time: 186.5, slave: "404CCA4392E0", data: "03XX0" },

    { time: 189, slave: "404CCA4392E0", data: "03XX1" },
    { time: 189.5, slave: "404CCA4462A8", data: "01XX1" },
    { time: 190, slave: "404CCA43FC38", data: "01XX1" },
    { time: 190.5, slave: "404CCA4368DC", data: "01XX1" },

    { time: 205, data: { isOn: "off", temp: 24 }, slave: "BLASTER" },
    { time: 211, data: { isOn: "on", temp: 24 }, slave: "BLASTER" },
    { time: 217, data: { isOn: "on", temp: 23 }, slave: "BLASTER" },
    { time: 218, data: { isOn: "on", temp: 22 }, slave: "BLASTER" },
    { time: 219, data: { isOn: "on", temp: 20 }, slave: "BLASTER" },
  ];

  const handleTimeUpdate = () => {
    const currentTime = videoRef.current?.currentTime || 0;

    videoTriggers?.forEach((trigger: any) => {
      const { time, slave, data } = trigger;

      if (!triggeredTimes.includes(time) && currentTime >= time) {
        if (slave === "BLASTER") {
          handelBlaster(data);
        } else {
          handleVideoST(slave, data);
        }
        setTriggeredTimes((prev) => [...prev, time]);
      }
    });
  };

  const handleVideoST = (slave: any, data: any) => {
    console.log(slave, data);
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "ST",
        data: data,
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
    }
  };
  const handelBlaster = (data: any) => {
    const reqObj = {
      cmd: "BIRL",
      device_type: "AC",
      brand: "Samsung",
      model: "UA55H6300",
      setting: {
        operate: data?.isOn,
        mode: "cool",
        temperature: data?.temp,
        fan_speed: 1,
        swing: 1,
      },
      device_id: "fcb467b7c904",
      token: "020df2ae008f70a4002fd03f014eb18a",
      tag: `airpanel-${userInfo?.id}`,
    };

    socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
  };

  return (
    <div>
      <style>{`
        .no-seekbar::-webkit-media-controls-timeline,
        .no-seekbar::-webkit-media-controls-seek-back-button,
        .no-seekbar::-webkit-media-controls-seek-forward-button {
          display: none !important;
        }
      `}</style>

      <Card
        style={{
          marginTop: 100,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 0,
        }}
      >
        <CardBody style={{ padding: 0 }}>
          <div
            className="d-flex justify-content-center align-items-center vh-100"
            style={{ transition: "background-color 0.5s ease" }}
          >
            <video
              ref={videoRef}
              onTimeUpdate={handleTimeUpdate}
              className="w-100 no-seekbar"
              controls
              controlsList="nodownload noplaybackrate noremoteplayback"
              disablePictureInPicture
            >
              <source
                src="https://whitelion-assets.blr1.cdn.digitaloceanspaces.com/airpanel/demo-room.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default DemoRoom;
